import React from 'react'

export default function CloseSvg({ fill = "#fff" }) {
  return (
      <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            fill="none"
        >
            <path
                fill={fill}
                d="M15.3 16.483 10 11.175l-5.3 5.308L3.517 15.3 8.825 10 3.517 4.7 4.7 3.517 10 8.825l5.3-5.3L16.475 4.7l-5.3 5.3 5.3 5.3-1.175 1.183Z"
            />
        </svg>
    
  )
}
